import React from 'react';
import { Alert, Button, Stack } from '@mui/material';

const ErrorBanner: React.FC<{ message: string; onRetry?: () => void }> = ({ message, onRetry }) => {
  return (
    <Alert severity="error" sx={{ mb: 2 }}
      action={onRetry ? (
        <Button color="inherit" size="small" onClick={onRetry}>
          Riprova
        </Button>
      ) : undefined}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <span>{message}</span>
      </Stack>
    </Alert>
  );
};

export default ErrorBanner;
